<template>
    <div class="ContentBox">
        <div class="commonBox TopsBlack"> <Tops :ishome="false"/></div>
        <el-carousel class="bannerBox"  trigger="click" indicator-position="outside" >
            <el-carousel-item v-for="item in 1" :key="item">
             <img src="@/assets/banner-2.png" />
            </el-carousel-item>
        </el-carousel>
        <!--  -->
        <PathBox />
        <!--  -->
        <div class="ConetBox commonBox" style="display:block!important">
          <template v-if="Info.total>0">
            <RecruitInfo  :ItemArr="Info['row']"  @TapClick="LookInfo"/>
            <div style="height: 30px"></div>
            <el-pagination
              v-if="Info['total']>0"
              @size-change="handleSizeChange"
              :current-page.sync="CurrPage"
              :page-size="15"
              layout="total, prev, pager, next"
              :total="Info['total']"
            >
            </el-pagination>
          </template>
          <template v-else>
            <Error />
          </template>

        </div>
        <Footer />
    </div>
</template>
<script>
import Tops from "@/components/PubBox/hearTop.vue";
import Footer from "@/components/PubBox/footer.vue";
import PathBox from "@/components/PubBox/PathBox.vue";
import RecruitInfo from "@/components/ListBox/RecruitInfo.vue";
import {GetNewsInfoByCid} from '@/requestPub/api';
import Error from '@/components/PubBox/Error.vue';
export default {
    components:{
        Tops,Footer,PathBox,RecruitInfo,Error
    },
    data() {
      return {
        currentPage1: 5,
        MenuAct:'',
        CurrInt:'',
        CurrPage:1,
        Info:new Object,
        CurrId:'',
      }
    },
    mounted(){
      this.CurrId = this.$route.query.id || '';
      this.GetInfo();
    },
    methods:{   
      GetInfo(){
        let parames = {
          PageSize: 15,
          PageIndex: this.CurrPage,
          Cid: this.CurrId
        }
        GetNewsInfoByCid(parames).then((e)=>{
          var Arrs = e.Data;
          Arrs['row'].map((item)=>{
            item['ShowTime'] = (item['ShowTime']).substr(0,10);
            item['Company'] = '四川万象坤信科技有限公司';
            item['jobType'] ='全职';
          })
          this.Info = Arrs;
        })
      },
      LookInfo(n){
        this.$router.push('/ListArtInfo?ids='+n);
      },
      LookNavList(n){
        this.CurrInt = n;
      },
      ChangeNavMenu(n){
        this.MenuAct= n;
      },
      handleSizeChange(val) {
        tis.CurrPage = val;
        this.GetInfo();
      }
    }
}
</script>
<style lang="scss">
.el-timeline{
  padding: 0;
}
  .bannerBox {
    height: 400px;
    .el-carousel__container {
      height: 100%;
    }
    .el-carousel__indicators--outside {
      position: absolute;
      bottom: 100px;
    }
    .el-carousel__item {
      img,
      .el-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  // ConetBox
  .ConetBox{
    p{
      text-indent: 40px;
      text-align: left;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 36px;
    }
    img{
      width: 100%;
    }
  }
</style>